import * as PandoraApi from './PandoraApiProtected';

export default {
  ...PandoraApi,
  supports: function supports(methodName) {
    // eslint-disable-next-line import/namespace
    return typeof PandoraApi[methodName] === 'function';
  },
};
